export default "__VITE_ASSET__480ab5b2__$_?component__"